import mixpanel from 'mixpanel-browser';
mixpanel.init(import.meta.env.VITE_APP_MIXPANEL_PROJECT_TOKEN);

const mp_active = import.meta.env.VITE_APP_MIXPANEL_PROJECT_TOKEN != undefined

type TrackObj = {
  [key: string]: string | number | undefined
}

const actions = {
  identify: (id: string) => {
    if (mp_active) mixpanel.identify(id);
  },
  alias: (id: string) => {
    if (mp_active) mixpanel.alias(id);
  },
  track: (name: string, props?: TrackObj) => {
    if (mp_active) mixpanel.track(name, props);
  },
  people: {
    set: (props: TrackObj) => {
      if (mp_active) mixpanel.people.set(props);
    },
  },
};

export default actions;
